'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerEyebrow = renderWithRef('BannerEyebrow', null, (o, n)=>{
    let { children: t } = o;
    return jsx(RenderComp, {
        root: "p",
        forwardedRef: n,
        classNames: [
            'swan-banner-eyebrow'
        ],
        props: o,
        children: t
    });
});

export { BannerEyebrow };
